export { default } from './header.component';